import { render, staticRenderFns } from "./addAdr.vue?vue&type=template&id=543dad23&scoped=true&"
import script from "./addAdr.vue?vue&type=script&lang=js&"
export * from "./addAdr.vue?vue&type=script&lang=js&"
import style0 from "./addAdr.vue?vue&type=style&index=0&id=543dad23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543dad23",
  null
  
)

export default component.exports